import { Color } from '@genial/design-tokens';

export const styleTemplate = `
  <style type="text/css">
    body {
      margin: 0;
      padding: 0;
      font-family: 'Source Sans Pro', sans-serif;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
      background-color: ${Color['neutral.white']};
      display: flex;
      justify-content: center;
    }

    .container {
      display: flex;
      flex: 1;
      background-color: ${Color['neutral.white']};
      align-items: center;
      justify-content: center;
    }

    .content {
      display: flex;
      flex: 1;
      flex-direction: column;
      max-width: 794px;
      padding: 36px 24px;
    }

    header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 16px;
    }

    .header-title {
      color: ${Color['brand.tertiary.dark']};
      font-size: 18px;
      font-family: Source Sans Pro;
      font-weight: 600;
      line-height: 27px;
      word-wrap: break-word;
    }

    .product-section {
      flex-direction: column;
      align-items: center;
      display: flex;
    }

    .product-summary,
    .product-details {
      width: 100%;
      gap: 13px;
      display: flex;
      padding-bottom: 8px;
    }

    .card {
      padding: 16px;
      background: ${Color.backgroundlight};
      border-radius: 8px;
      flex-direction: column;
      gap: 8px;
      display: flex;
      flex: 1;
    }

    .card-title {
      color: ${Color['neutral.dark']};
      font-size: 11px;
      font-family: Source Sans Pro;
      font-weight: 400;
      line-height: 16.50px;
      word-wrap: break-word;
    }

    .card-value {
      color: black;
      font-size: 11px;
      font-family: Source Sans Pro;
      font-weight: 400;
      line-height: 16.50px;
      word-wrap: break-word;
    }

    .divider {
      align-self: stretch;
      height: 0px;
      border: 1px ${Color['brand.primary.lightest']} solid;
    }

    .total-value-card {
      padding: 16px;
      background: ${Color.backgroundlight};
      border-radius: 8px;
      flex-direction: column;
      gap: 4px;
      display: flex;
    }

    .total-value-title {
      color: ${Color['neutral.dark']};
      font-size: 10px;
      font-family: Source Sans Pro;
      font-weight: 600;
      text-transform: uppercase;
      line-height: 15px;
      word-wrap: break-word;
    }

    .total-value {
      color: ${Color['brand.tertiary.dark']};
      font-size: 12px;
      font-family: Source Sans Pro;
      font-weight: 600;
      line-height: 18px;
      word-wrap: break-word;
    }

    .product-details-header {
      padding: 4px 8px;
      background: ${Color['brand.tertiary.dark']};
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    .card-header {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
    }

    .product-details-title {
      color: ${Color['neutral.white']};
      font-size: 11px;
      font-family: Source Sans Pro;
      font-weight: 400;
      line-height: 16.50px;
      word-wrap: break-word;
    }

    .product-card {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 0 8px 0;
    }

    .product-table {
      display: flex;
      flex: 1;
    }

    .product-type-title {
      color: ${Color['brand.tertiary.dark']};
      font-size: 12px;
      font-family: Source Sans Pro;
      font-weight: 600;
      line-height: 18px;
      word-wrap: break-word;
    }

    .product-info {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .product-info-text {
      color: ${Color['neutral.medium']};
      font-size: 10px;
      font-family: Source Sans Pro;
      font-weight: 600;
      text-transform: uppercase;
      line-height: 15px;
      word-wrap: break-word;
    }

    .product-last-price {
      display: flex;
      flex-direction: column;
    }

    .product-last-price-value {
      display: flex;
      gap: 4px;
    }

    .product-last-price-updated {
      color: ${Color['neutral.medium']};
    }

    .product-table-content {
      flex: 1;
      padding: 16px;
      background: rgba(232, 234, 250, 0.30);
      border-radius: 0 8px 8px 0;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }

    thead>tr {
      color: ${Color['neutral.medium']};
      font-size: 9px;
      font-family: Source Sans Pro;
      font-weight: 600;
      text-transform: uppercase;
      line-height: 18px;
      border-bottom: 1px ${Color['brand.primary.lightest']} solid;
    }

    td {
      padding: 8px 0
    }

    td>span {
      color: ${Color['neutral.medium']};
      font-size: 9px;
      font-family: Source Sans Pro;
      font-weight: 400;
      line-height: 13.50px;
      word-wrap: break-word
    }

    tbody>tr {
      color: black;
      font-size: 9px;
      font-family: Source Sans Pro;
      font-weight: 400;
      line-height: 18px;
      border-bottom: 1px ${Color['brand.tertiary.lightest']} solid;
    }

    th {
      text-align: left
    }

    .highlight-bar {
      width: 4px;
      align-self: stretch;
      border-radius: 8px 0 0 8px;
    }

    .highlight-bar.fixed-income {
      background: ${Color['product.rf']};
    }

    .highlight-bar.funds {
      background: ${Color['product.fundos']};
    }

    .highlight-bar.equities {
      background: ${Color['product.rendavariavel']};
    }

    .highlight-bar.coes {
      background: ${Color['product.estruturados']};
    }

    .highlight-bar.direct-treasury {
      background: ${Color['product.tesouro']};
    }
  </style>
`;
